"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireDefault(require("react")),
    _lodash = _interopRequireDefault(require("lodash.isequal")),
    _lodash2 = _interopRequireDefault(require("lodash.omit")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _Progress = _interopRequireDefault(require("./Progress")),
    _AssetUploader = _interopRequireDefault(require("../uploaders/AssetUploader")),
    _UploaderContext = require("./UploaderContext"),
    _utils = require("../utils"),
    _constants = require("../constants");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var Uploader = function (_React$Component) {
  function Uploader(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Uploader), _this = _super.call(this, props), _initialiseProps.call((0, _assertThisInitialized2["default"])(_this));
    var apiClient = props.apiClient;
    return _this.state = {
      assetsMap: new Map(),
      uploader: new _AssetUploader["default"](apiClient)
    }, _this;
  }

  (0, _inherits2["default"])(Uploader, _React$Component);

  var _super = _createSuper(Uploader);

  return (0, _createClass2["default"])(Uploader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          organisationId = _this$props.organisationId,
          assetsMap = this.state.assetsMap;
      return organisationId ? _react["default"].createElement(_UploaderContext.UploaderProvider, {
        value: this.getProviderValue(assetsMap)
      }, children, _react["default"].createElement(_Progress["default"], {
        items: this.fetchUploadingAssets(),
        retry: this.retryFileUpload,
        remove: this.remove
      })) : children;
    }
  }]), Uploader;
}(_react["default"].Component);

exports["default"] = Uploader;

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.componentDidMount = function () {
    _this2.initUnFinishedUploads();
  }, this.getProviderValue = (0, _memoizeOne["default"])(function (assetsMap) {
    return {
      addFileToQueue: _this2.addFileToQueue,
      assetsMap: assetsMap,
      fetchAssets: _this2.fetchAssets,
      fetchAssetsForResource: _this2.fetchAssetsForResource,
      addAssetsToMap: _this2.addAssetsToMap,
      removeAsset: _this2.removeAsset
    };
  }), this.addFileToQueue = function (inputPayload, organisationId) {
    var selectedOrgId = _this2.props.organisationId;
    return _this2.addFileForOrganisation(inputPayload, organisationId || selectedOrgId);
  }, this.removeAsset = function (assetId) {
    _this2.setState(function (_ref) {
      var prevAssetsMap = _ref.assetsMap,
          assetsMap = new Map((0, _toConsumableArray2["default"])(prevAssetsMap));
      return assetsMap.set(assetId, null), {
        assetsMap: assetsMap
      };
    });
  }, this.setAssetAsMissing = function (asset) {
    var apiClient = _this2.props.apiClient,
        organisationId = asset.organisationId,
        _asset$assetFiles = asset.assetFiles,
        ORIGINAL = _asset$assetFiles.ORIGINAL,
        THUMBNAIL = _asset$assetFiles.THUMBNAIL;
    return THUMBNAIL && (0, _utils.updateFile)(apiClient, {
      organisationId: organisationId,
      assetFileId: THUMBNAIL.assetFileId,
      input: {
        status: _constants.ASSET_STATUS.MISSING
      }
    }), void (0, _utils.updateFile)(apiClient, {
      organisationId: organisationId,
      assetFileId: ORIGINAL.assetFileId,
      input: {
        status: _constants.ASSET_STATUS.MISSING
      }
    });
  }, this.initUnFinishedUploads = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
    var apiClient, inProgressAssets;
    return _regenerator["default"].wrap(function (_context) {
      for (;;) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(0, _utils.isUserAnonymousOrAuthFalsy)()) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            return apiClient = _this2.props.apiClient, _context.next = 5, (0, _utils.getAssets)(apiClient, {
              status: "IN_PROGRESS"
            });

          case 5:
            if (inProgressAssets = _context.sent, inProgressAssets) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return");

          case 8:
            inProgressAssets.forEach(function (asset) {
              var assetId = asset.assetId,
                  localAsset = (0, _utils.getAssetFromLocalStorage)(assetId);
              if (!localAsset || !localAsset.bucketKey || !localAsset.filename) return void _this2.setAssetAsMissing(asset);

              var bucketKey = localAsset.bucketKey,
                  loaded = localAsset.uploadedBytes,
                  metaData = localAsset.metaData,
                  _JSON$parse = JSON.parse(metaData),
                  fileSize = _JSON$parse.size,
                  loadedPercent = Math.floor(100 * (loaded / fileSize));

              _this2.handleAssetUpdates([_objectSpread({}, asset, {
                bucketKey: bucketKey,
                loaded: loaded,
                totalSize: fileSize,
                loadedPercent: loadedPercent,
                uploadStatus: _constants.ITEM_STATUS.ERROR
              })]);
            }), (0, _utils.refreshAssetsLocalStorage)(inProgressAssets.map(function (asset) {
              return asset.assetId;
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), this.setAssetsInState = function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(assetIds) {
      var apiClient, asset, assets, deletedAssetIds;
      return _regenerator["default"].wrap(function (_context2) {
        for (;;) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (apiClient = _this2.props.apiClient, 1 !== assetIds.length) {
                _context2.next = 15;
                break;
              }

              return _context2.next = 4, (0, _utils.getAsset)(apiClient, {
                assetId: assetIds[0]
              });

            case 4:
              if (asset = _context2.sent, !asset) {
                _context2.next = 11;
                break;
              }

              return _context2.next = 8, _this2.handleAssetUpdates([asset]);

            case 8:
              _context2.t0 = _context2.sent, _context2.next = 14;
              break;

            case 11:
              return _context2.next = 13, _this2.handleDeletedAssets(assetIds);

            case 13:
              _context2.t0 = _context2.sent;

            case 14:
              return _context2.abrupt("return", void _context2.t0);

            case 15:
              return _context2.next = 17, (0, _utils.getAssets)(apiClient, {
                assetIds: assetIds
              });

            case 17:
              if (assets = _context2.sent, assets) {
                _context2.next = 20;
                break;
              }

              return _context2.abrupt("return");

            case 20:
              return deletedAssetIds = assetIds.filter(function (assetId) {
                return !assets.some(function (singleAsset) {
                  return singleAsset && singleAsset.assetId === assetId;
                });
              }), _context2.next = 23, _this2.handleDeletedAssets(deletedAssetIds);

            case 23:
              return _context2.next = 25, _this2.handleAssetUpdates(assets);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function () {
      return _ref3.apply(this, arguments);
    };
  }(), this.assetIdsAccumulator = function (accumulatedAssetIds) {
    return function (assetIds) {
      accumulatedAssetIds.push.apply(accumulatedAssetIds, (0, _toConsumableArray2["default"])(assetIds));
    };
  }, this.setResourceAssetsInState = function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3(resourceId, organisationId, assetIds) {
      var apiClient, assets, deletedAssetIds;
      return _regenerator["default"].wrap(function (_context3) {
        for (;;) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return apiClient = _this2.props.apiClient, _context3.next = 3, (0, _utils.getAssetsForResource)(apiClient, {
                resourceId: resourceId,
                organisationId: organisationId
              });

            case 3:
              if (assets = _context3.sent, assets) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return");

            case 6:
              return deletedAssetIds = assetIds.filter(function (assetId) {
                return !assets.some(function (singleAsset) {
                  return singleAsset.assetId === assetId;
                });
              }), _context3.next = 9, _this2.handleDeletedAssets(deletedAssetIds);

            case 9:
              return _context3.next = 11, _this2.handleAssetUpdates(assets);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function () {
      return _ref4.apply(this, arguments);
    };
  }(), this.fetchAssets = function (data) {
    (0, _utils.findAllAssetIds)(data, _this2.setAssetsInState);
  }, this.fetchAssetsForResource = function (_ref5) {
    var data = _ref5.data,
        resourceId = _ref5.resourceId,
        organisationId = _ref5.organisationId,
        accumulatedAssetIds = [],
        selectedOrgId = _this2.props.organisationId;
    (0, _utils.findAllAssetIds)(data, _this2.assetIdsAccumulator(accumulatedAssetIds));
    accumulatedAssetIds.length && _this2.setResourceAssetsInState(resourceId, organisationId || selectedOrgId, Array.from(new Set(accumulatedAssetIds)));
  }, this.addAssetsToMap = function (assets) {
    _this2.handleAssetUpdates(assets);
  }, this.fetchUploadingAssets = function () {
    var assetsMap = _this2.state.assetsMap;
    return Array.from(assetsMap.values()).filter(function (asset) {
      var uploadStatus = (asset || {}).uploadStatus;
      return uploadStatus;
    });
  }, this.retryFileUpload = function (assetId, organisationId, file) {
    var uploader = _this2.state.uploader;
    return uploader && uploader.retryAssetUpload({
      handleAssetUpdates: _this2.handleAssetUpdates,
      assetId: assetId,
      organisationId: organisationId,
      file: file
    });
  }, this.deletesAlreadyPresent = function (assetIds) {
    var assetsMap = _this2.state.assetsMap;
    return assetIds.map(function (assetId) {
      return null === assetsMap.get(assetId);
    }).reduce(function (a, b) {
      return a && b;
    }, !0);
  }, this.handleDeletedAssets = function (assetIds) {
    return new Promise(function (resolve) {
      return _this2.deletesAlreadyPresent(assetIds) ? void resolve() : void _this2.setState(function (_ref7) {
        var prevAssetsMap = _ref7.assetsMap;
        return {
          assetsMap: new Map([].concat((0, _toConsumableArray2["default"])(prevAssetsMap), (0, _toConsumableArray2["default"])(assetIds.map(function (assetId) {
            return [assetId, null];
          }))))
        };
      }, resolve);
    });
  }, this.updatesAlreadyPresent = function (newAssets) {
    var assetsMap = _this2.state.assetsMap;
    return newAssets.map(function (newAsset) {
      if (!assetsMap.has(newAsset.assetId)) return !1;

      var existingAsset = assetsMap.get(newAsset.assetId) || {},
          omittedExistingAsset = _objectSpread({}, existingAsset, {
        assetFiles: _objectSpread({}, existingAsset.assetFiles ? Object.entries(existingAsset.assetFiles).map(function (_ref8) {
          var _ref9 = (0, _slicedToArray2["default"])(_ref8, 2),
              fileType = _ref9[0],
              fileObjectValues = _ref9[1];

          return (0, _defineProperty2["default"])({}, fileType, (0, _lodash2["default"])(fileObjectValues, "sourceUrl"));
        }).reduce(function (a, b) {
          return _objectSpread({}, a, {}, b);
        }, {}) : {})
      }),
          omittedNewAsset = _objectSpread({}, newAsset, {
        assetFiles: _objectSpread({}, newAsset.assetFiles ? Object.entries(newAsset.assetFiles).map(function (_ref11) {
          var _ref12 = (0, _slicedToArray2["default"])(_ref11, 2),
              fileType = _ref12[0],
              fileObjectValues = _ref12[1];

          return (0, _defineProperty2["default"])({}, fileType, (0, _lodash2["default"])(fileObjectValues, "sourceUrl"));
        }).reduce(function (a, b) {
          return _objectSpread({}, a, {}, b);
        }, {}) : {})
      });

      return (0, _lodash["default"])(omittedExistingAsset, omittedNewAsset);
    }).reduce(function (a, b) {
      return a && b;
    }, !0);
  }, this.handleAssetUpdates = function (newAssets) {
    return new Promise(function (resolve) {
      return _this2.updatesAlreadyPresent(newAssets) ? void resolve() : void _this2.setState(function (_ref14) {
        var prevAssetsMap = _ref14.assetsMap;
        return {
          assetsMap: new Map([].concat((0, _toConsumableArray2["default"])(prevAssetsMap), (0, _toConsumableArray2["default"])(newAssets.map(function (asset) {
            return [asset.assetId, _objectSpread({}, prevAssetsMap.get(asset.assetId) || {}, {}, asset)];
          }))))
        };
      }, resolve);
    });
  }, this.addFileForOrganisation = function () {
    var _ref15 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4(inputPayload, organisationId) {
      var uploader, file, metaData, payload, asset;
      return _regenerator["default"].wrap(function (_context4) {
        for (;;) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(0, _utils.isUserAnonymousOrAuthFalsy)()) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return", null);

            case 2:
              return uploader = _this2.state.uploader, file = inputPayload.file, metaData = inputPayload.metaData, payload = _objectSpread({}, inputPayload, {
                organisationId: organisationId,
                metaData: _objectSpread({
                  type: file.type,
                  size: file.size
                }, metaData)
              }), _context4.next = 7, uploader.createAsset(payload);

            case 7:
              if (asset = _context4.sent, asset) {
                _context4.next = 10;
                break;
              }

              return _context4.abrupt("return", null);

            case 10:
              return uploader.uploadAsset({
                asset: asset,
                handleAssetUpdates: _this2.handleAssetUpdates,
                file: payload.file
              }), _context4.abrupt("return", asset.assetId);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function () {
      return _ref15.apply(this, arguments);
    };
  }(), this.remove = function () {
    var _ref16 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee5(assetId) {
      var apiClient, asset;
      return _regenerator["default"].wrap(function (_context5) {
        for (;;) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return apiClient = _this2.props.apiClient, _context5.next = 3, (0, _utils.getAsset)(apiClient, {
                assetId: assetId
              });

            case 3:
              if (asset = _context5.sent, asset) {
                _context5.next = 6;
                break;
              }

              return _context5.abrupt("return");

            case 6:
              _this2.setAssetAsMissing(asset), (0, _utils.deleteAssetFromLocalStorage)(assetId), _this2.removeAsset(assetId);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function () {
      return _ref16.apply(this, arguments);
    };
  }();
};